module.exports = __webpack_public_path__ + "img/6-Kablo Tel D眉nyas谋.b29cfe36.png";